import React, { Component } from 'react';
import { connect } from 'react-redux';
import RejectReasonListModal from '../../../../views/product/common/modal/RejectReasonListModal';
import withModal from '../../../../lib/hoc/withModal';
import { productActions } from '../../../../store/modules/product';

class RejectReasonListModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'rejectReasonListModal', value: false });
  };

  render() {
    return (
      <RejectReasonListModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.rejectReasonListModal.isOpen,
    data: state.product.rejectReasonListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: productActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(RejectReasonListModalContainer));
